// extracted by mini-css-extract-plugin
export default {"main_container":"Testimonial_main_container__MS0zy","heading":"Testimonial_heading__kMVFm","review":"Testimonial_review__jVgHJ"};